/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
// Kept in plain JS: `glowingblue/newvigation` ships no `dist-typings`.
import NavElements from 'flarum/newvigation/components/NavElements';
import LinkButton from 'flarum/common/components/LinkButton';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import UserPage from 'flarum/forum/components/UserPage';

// The `book_collections` route is registered in ../setupRouting.ts.
export default function () {
	const navLink = (active) => (
		<LinkButton href={app.route.all_book_collections()} icon="far fa-books" active={active}>
			{app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.nav')}
		</LinkButton>
	);

	if (app.initializers.has('glowingblue-newvigation')) {
		extend(NavElements.prototype, 'items', function (items) {
			if (m.route.get()) {
				items.add('book_collections', navLink(m.route.get().indexOf('book_collections') >= 0), 139);
			}
		});
	} else {
		extend(IndexPage.prototype, 'navItems', function (items) {
			if (m.route.get()) {
				items.add('book_collections', navLink(m.route.get().indexOf('book_collections') >= 0), 90);
			}
		});
	}

	extend(SessionDropdown.prototype, 'items', (items) => {
		if (app.session.user?.canCreateBookshelves() && m.route.get()) {
			items.add(
				'book_collections',
				<LinkButton href={app.route.book_collections()} icon="far fa-books" active={m.route.get().indexOf('/book_collections') === 0}>
					{app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.own_title')}
				</LinkButton>,
				99
			);
		}
	});

	extend(UserPage.prototype, 'navItems', function (items) {
		const user = this.user;

		if (app.forum.attribute('canViewBookshelves') && user && user.bookshelfCount() > 0) {
			items.add(
				'book_collections',
				<LinkButton href={app.route('user.book_collections', { username: user.slug() })} icon="far fa-books">
					{app.translator.trans('glowingblue-orell-bookshelf.forum.user.nav')}
					<span className="Button-badge">{user.bookshelfCount()}</span>
				</LinkButton>,
				89
			);
		}
	});
}
